import React from "react";
import CrudForm from "../../components/forms/custom/CrudForm";
import BtnButton from "../../components/forms/elements/BtnButton";
import BtnSubmit from "../../components/forms/elements/BtnSubmit";
import Util from "../../utils/Util";
import Config from "../../Config";
import BtnGroup from "../../components/forms/elements/BtnGroup";
import InputCheckSwitch from "../../components/forms/elements/InputCheckSwitch";
import Permissao from "../../controllers/Permissao";

export default class FormRelatorioOrdem001 extends CrudForm {

    constructor(props) {
        super(props);

        this.state.isModal = true;

        this.urlRelatorio = "relatorio/ordem-001";

        this.state.model = {
            idOrdens: props.idOrdens,
            orientation: "P",
            destination: "I",
            flMostrarValor: Permissao.getInstance().getPermissao(22),
            flMarcaDagua: true,
            flMostrarComentario: false,
            flMostrarComentarioPrivado : false,
            flOrcamento : false
        };

        this.state.orientation = [
            { value: 'P', label: 'Vertical' },
            { value: 'L', label: 'Horizontal' },
        ]

        this.state.destination = [
            { value: 'I', label: 'Tela' },
            { value: 'D', label: 'Download' },
        ]
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    onSubmit(e) {
        Util.openNewWindow(Config.getUrlApi() + this.urlRelatorio, this.state.model);
    }

    getRenderFields() {
        return (
            <>
                <div className="row mb-3">
                    <BtnGroup md={6} sizing="sm" className="w-100" name="orientation" value={this.state.model.orientation} label="Disposição da Página" options={this.state.orientation} onChange={this.handleChange} required />
                    <BtnGroup md={6} sizing="sm" className="w-100" name="destination" value={this.state.model.destination} label="Destino do Relatório" options={this.state.destination} onChange={this.handleChange} required />
                </div>
                <div className="row px-3 mb-3">
                    {Permissao.getInstance().getPermissao(22) ?
                        <InputCheckSwitch label="Mostrar valor dos itens?" name="flMostrarValor" checked={Boolean(this.state.model.flMostrarValor)} onChange={this.handleChange} />
                        : <></>}
                    
                    <InputCheckSwitch label="Mostrar como Orçamento" name="flOrcamento" checked={Boolean(this.state.model.flOrcamento)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Mostrar marca d'água" name="flMarcaDagua" checked={Boolean(this.state.model.flMarcaDagua)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Mostrar comentários" name="flMostrarComentario" checked={Boolean(this.state.model.flMostrarComentario)} onChange={this.handleChange} />

                    {Permissao.getInstance().getPermissao(108) && Boolean(this.state.model.flMostrarComentario) ?
                        <InputCheckSwitch label="Mostrar comentários privados?" name="flMostrarComentarioPrivado" checked={Boolean(this.state.model.flMostrarComentarioPrivado)} onChange={this.handleChange} />
                        : <></>}

                </div>
            </>
        );
    }

    getBtns() {
        return (
            <div className="d-grid gap-2 d-md-flex">
                <BtnButton className="ms-auto btn-outline-secondary" onClick={this.handleClose}> Cancelar </BtnButton>
                <div className="vr"></div>
                <BtnSubmit className="btn-primary"> Emitir Relatório </BtnSubmit>
            </div>);
    }

    render() {
        return super.render();
    }
}